import React, { useState, useEffect, useRef, useImperativeHandle, forwardRef, } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Select from "react-select"; // 👈 instalar con npm install react-select
import Breadcrumb from "../components/Breadcrumb";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "../styles/Odontograma.css";
import html2canvas from "html2canvas";
import ModalConfirmacion from "../components/ModalConfirmacion";

import d11 from "../assets/dientes/adulto/11.png";
import d12 from "../assets/dientes/adulto/12.png";
import d13 from "../assets/dientes/adulto/13.png";
import d14 from "../assets/dientes/adulto/14.png";
import d15 from "../assets/dientes/adulto/15.png";
import d16 from "../assets/dientes/adulto/16.png";
import d17 from "../assets/dientes/adulto/17.png";
import d18 from "../assets/dientes/adulto/18.png";
import d21 from "../assets/dientes/adulto/21.png";
import d22 from "../assets/dientes/adulto/22.png";
import d23 from "../assets/dientes/adulto/23.png";
import d25 from "../assets/dientes/adulto/24.png";
import d24 from "../assets/dientes/adulto/25.png";
import d26 from "../assets/dientes/adulto/26.png";
import d27 from "../assets/dientes/adulto/27.png";
import d28 from "../assets/dientes/adulto/28.png";
import d31 from "../assets/dientes/adulto/31.png";
import d32 from "../assets/dientes/adulto/32.png";
import d33 from "../assets/dientes/adulto/33.png";
import d34 from "../assets/dientes/adulto/34.png";
import d35 from "../assets/dientes/adulto/35.png";
import d36 from "../assets/dientes/adulto/36.png";
import d37 from "../assets/dientes/adulto/37.png";
import d38 from "../assets/dientes/adulto/38.png";
import d41 from "../assets/dientes/adulto/41.png";
import d42 from "../assets/dientes/adulto/42.png";
import d43 from "../assets/dientes/adulto/43.png";
import d44 from "../assets/dientes/adulto/44.png";
import d45 from "../assets/dientes/adulto/45.png";
import d46 from "../assets/dientes/adulto/46.png";
import d47 from "../assets/dientes/adulto/47.png";
import d48 from "../assets/dientes/adulto/48.png";

import d51 from "../assets/dientes/nino/51.png";
import d52 from "../assets/dientes/nino/52.png";
import d53 from "../assets/dientes/nino/53.png";
import d54 from "../assets/dientes/nino/54.png";
import d55 from "../assets/dientes/nino/55.png";
import d61 from "../assets/dientes/nino/61.png";
import d62 from "../assets/dientes/nino/62.png";
import d63 from "../assets/dientes/nino/63.png";
import d64 from "../assets/dientes/nino/64.png";
import d65 from "../assets/dientes/nino/65.png";
import d71 from "../assets/dientes/nino/71.png";
import d72 from "../assets/dientes/nino/72.png";
import d73 from "../assets/dientes/nino/73.png";
import d74 from "../assets/dientes/nino/74.png";
import d75 from "../assets/dientes/nino/75.png";
import d81 from "../assets/dientes/nino/81.png";
import d82 from "../assets/dientes/nino/82.png";
import d83 from "../assets/dientes/nino/83.png";
import d84 from "../assets/dientes/nino/84.png";
import d85 from "../assets/dientes/nino/85.png";

const palette = [
    "#ff4d4f", // rojo
    "#1890ff", // azul
    "#52c41a", // verde
    "#fa8c16", // naranja
    "#722ed1", // morado
    "#13c2c2", // turquesa
    "#eb2f96", // rosa
    "#a0d911", // lima
    "#fa541c", // naranja oscuro
    "#2f54eb", // azul intenso
];

function colorPorDenominacion(nombre) {
  if (!nombre || typeof nombre !== "string") {
    return palette[0]; // color seguro por defecto
  }

  let hash = 0;
  for (let i = 0; i < nombre.length; i++) {
    hash = nombre.charCodeAt(i) + ((hash << 5) - hash);
  }
  const index = Math.abs(hash) % palette.length;
  return palette[index];
}

const Odontograma = forwardRef(({ soloLectura = false, piezasPresupuesto = [], hideChrome = false }, ref) => {
    const { expediente } = useParams();
    const [modo, setModo] = useState("adulto");
    const [odontograma, setOdontograma] = useState({ n_expediente: Number(expediente), fecha: new Date().toISOString().slice(0,10), datos: {} });
    const [menuContextual, setMenuContextual] = useState({ visible:false, x:0, y:0, diente:null });
    const [tratamientos, setTratamientos] = useState([]);
    const [dienteActivo, setDienteActivo] = useState(null);
    const [filtroTratamiento, setFiltroTratamiento] = useState('');
    const [capturando, setCapturando] = useState(false);
    const [paciente, setPaciente] = useState(null);
    const [cargando, setCargando] = useState(true);
    const [guardando, setGuardando] = useState(false);
    const [mostrarConfirmacion, setMostrarConfirmacion] = useState(false);
    const [dienteAEliminar, setDienteAEliminar] = useState(null);



    const containerRef = useRef(null);

  // Diccionarios de imágenes -> dientesAdulto/dientesNino...
    const dientesAdulto = {
        11: d11, 12: d12, 13: d13, 14: d14, 15: d15, 16: d16, 17: d17, 18: d18,
        21: d21, 22: d22, 23: d23, 24: d24, 25: d25, 26: d26, 27: d27, 28: d28,
        31: d31, 32: d32, 33: d33, 34: d34, 35: d35, 36: d36, 37: d37, 38: d38,
        41: d41, 42: d42, 43: d43, 44: d44, 45: d45, 46: d46, 47: d47, 48: d48 
        };
    const dientesNino = {
        51: d51, 52: d52, 53: d53, 54: d54, 55: d55,
        61: d61, 62: d62, 63: d63, 64: d64, 65: d65,
        71: d71, 72: d72, 73: d73, 74: d74, 75: d75,
        81: d81, 82: d82, 83: d83, 84: d84, 85: d85
        };
    const dientes = modo === "adulto" ? dientesAdulto : dientesNino;

    useEffect(() => {
    async function fetchTratamientos() {
        try {
        const { data } = await axios.get("/api/tratamientos", {
            headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
        });
        setTratamientos(
            data.map(t => ({
              value: t.denominacion,
              label: `${t.denominacion} (${t.importe} €)`,
              denominacion: t.denominacion,
              color: colorPorDenominacion(t.denominacion)
            }))
        );
        } catch (err) {
        console.error("Error al cargar tratamientos", err);
        }
    }
    fetchTratamientos();
    }, []);

    // 🟢 1. Cargar odontograma solo si no es desde presupuesto
    useEffect(() => {
        if (piezasPresupuesto && piezasPresupuesto.length > 0) {
          setCargando(false);
          return;
        }
        async function fetchOdontograma() {
          try {
          setCargando(true);
          const { data } = await axios.get(`/api/odontograma/${expediente}`, {
              headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
          });
          if (Array.isArray(data) && data.length > 0) {
              const ultimo = data[data.length - 1];
              setOdontograma({
              ...ultimo,
              datos: ultimo.datos ? JSON.parse(ultimo.datos) : {}
              });
          } else {
              setOdontograma(prev => ({ ...prev, datos: {} }));
          }
          } catch (err) {
          console.error("Error al cargar odontograma", err);
          } finally {
            setCargando(false);
          }
        }
        fetchOdontograma();
    }, [expediente]);

    // 🟢 2. Pintar piezas del presupuesto una única vez (sin sobrescribir luego)
    useEffect(() => {
        if (!piezasPresupuesto || piezasPresupuesto.length === 0) return;
        setOdontograma(prev => {
            // si ya hay datos cargados y coincide con las piezas, no repintar
            const nuevosDatos = { ...prev.datos };
            piezasPresupuesto.forEach(act => {
                const num = String(act.pieza);
                if (!num) return;
                const tratamiento = { value: act.denominacion, label: act.denominacion };
                nuevosDatos[num] = { tratamientos: [tratamiento] };
            });
            return { ...prev, datos: nuevosDatos };
        });
    }, [piezasPresupuesto]);



  // Seleccionar tratamiento (cierra selector al final con setDienteActivo(null))
    const seleccionarTratamiento = (diente, tratamiento) => {
        if (!tratamiento) return;
        setOdontograma(prev => {
            const actuales = prev.datos[String(diente)]?.tratamientos || [];
            const nuevo = { value: tratamiento.value};
            const actualizados = [...actuales.filter(t => t.value !== nuevo.value), nuevo];
            return { ...prev, datos: { ...prev.datos, [String(diente)]: { tratamientos: actualizados } } };
        });
        // cerrar selector inmediatamente
        setDienteActivo(null);
    };

    // Abrir/cerrar menú contextual
    const abrirMenuContextual = (e, num) => {
        e.preventDefault();
        setMenuContextual({ visible:true, x:e.pageX, y:e.pageY, diente:num });
    };
    const cerrarMenuContextual = () => setMenuContextual({...menuContextual, visible:false});
    
    const solicitarEliminarDiente = () => {
      if (!menuContextual.diente) return;
      setDienteAEliminar(menuContextual.diente);
      setMostrarConfirmacion(true);
      cerrarMenuContextual();
    };

    const confirmarEliminarDiente = () => {
      if (!dienteAEliminar) return;

      setOdontograma(prev => {
        const nuevos = { ...prev.datos };
        delete nuevos[String(dienteAEliminar)];
        return { ...prev, datos: nuevos };
      });

      setDienteAEliminar(null);
      setMostrarConfirmacion(false);
    };

    const cancelarEliminarDiente = () => {
      setDienteAEliminar(null);
      setMostrarConfirmacion(false);
    };


    function generarBordes(num) {
        const datosDiente = odontograma.datos[num];
        if (!datosDiente || !datosDiente.tratamientos?.length) return {};

        // Devuelve una lista de colores
        const colores = datosDiente.tratamientos
          .map(trat => colorPorDenominacion(trat?.value))
          .filter(Boolean);


        const estilos = {
            border: `3px solid ${colores[0]}`,
            borderRadius: "8px",
            boxSizing: "border-box",
            position: "relative",
        };

        // Si hay más de un tratamiento, añadimos las variables CSS
        if (colores[1]) estilos["--color-borde-1"] = colores[0];
        if (colores[1]) estilos["--color-borde-2"] = colores[1];

        return estilos;
    }


    const capture = async () => {
        if (!containerRef.current) return null;

        // Espera a que los dientes estén dibujados
        await new Promise(res => setTimeout(res, 250));

        const canvas = await html2canvas(containerRef.current, {
            backgroundColor: "#fff",
            scale: 2,
            useCORS: true
        });

        return canvas.toDataURL("image/png");
    };


    useImperativeHandle(ref, () => ({
        capture: async () => {
            return await capture();
        }
    }));

    // Guardar (captura + POST) — opcional: usar ref.capture() desde otro sitio
    const guardarOdontograma = async () => {
        try {
            setGuardando(true);
            const imagenBase64 = await capture();
            const data = {
              n_expediente: Number(expediente),
              fecha: new Date().toISOString().split("T")[0],
              datos: JSON.stringify(odontograma.datos),
              imagen_odontograma: imagenBase64
            };
            await axios.post("/api/odontograma", data, {
              headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
            });
            toast.success("Odontograma guardado correctamente");
        } catch (err) {
          toast.error("Error al guardar odontograma");
          console.error("Error al guardar odontograma", err);
        } finally {
          setGuardando(false);
        }
    };

  // click fuera para cerrar selector (ya lo tenías)
  useEffect(() => {
    const handle = e => {
      if (dienteActivo) {
        const selector = document.querySelector(".selector-tratamiento");
        if (selector && !selector.contains(e.target)) setDienteActivo(null);
      }
    };
    document.addEventListener("mousedown", handle);
    return () => document.removeEventListener("mousedown", handle);
  }, [dienteActivo]);

  useEffect(() => {
    async function fetchPaciente() {
      try {
        const { data } = await axios.get(`/api/pacientes/${expediente}`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        setPaciente(data);
      } catch (err) {
        console.error("Error al cargar paciente:", err);
      }
    }

    fetchPaciente();
  }, [expediente]);

  // JSX (simplificado; adapta arrays de dientes, etc.)
  if (cargando) {
    return (
      <>
        {!hideChrome && <Breadcrumb />}
        <div className="odontograma-container">
          <h3>Cargando odontograma…</h3>
          <div className="spinner"></div>
        </div>
      </>
    );
  }
  return (
    <>
    {!hideChrome && <ToastContainer position="top-right" autoClose={3000} />}
    {!hideChrome && <div style={{ marginBottom: '20px' }}></div>}
    {!hideChrome && <Breadcrumb />}
    <div className="odontograma-container">
        <h3>
          Odontograma de{" "}
          {paciente
            ? [paciente.nombre, paciente.primer_apellido, paciente.segundo_apellido]
                .filter(Boolean)   // elimina vacíos
                .join(" ")
            : expediente}
        </h3>

        <div className="modo-toggle">
          <button className={modo === "adulto" ? "activo" : ""} onClick={() => setModo("adulto")}>Adulto</button>
          <button className={modo === "nino" ? "activo" : ""} onClick={() => setModo("nino")}>Niño</button>
        </div>

        {/* guardar solo si no es soloLectura */}
        {!soloLectura && !capturando && (
          <button className="guardar-btn" onClick={guardarOdontograma} disabled={guardando}>
            {guardando ? <div className="spinner"></div> : "Guardar Odontograma"}
          </button>
        )}

        <div className="contenedor-odontograma-flex">
          <div 
            ref={containerRef}
            className={`odontograma-principal ${capturando ? "capturando" : ""}`}
          >
            <div className="arcada superior">
              {(modo === "adulto" ? [18,17,16,15,14,13,12,11,21,22,23,24,25,26,27,28] : [55,54,53,52,51,61,62,63,64,65])
                .map(num => (
                  <div key={num} className="diente" style={generarBordes(num)}
                    data-bordes
                    onClick={() => setDienteActivo(String(num))}
                    onContextMenu={(e) => abrirMenuContextual(e, num)}
                  >
                    <div className="numero-diente-superior">{num}</div>
                    <img src={dientes[num]} alt={`Diente ${num}`} />
                    {/* mostrador de select solo si NO es modo lectura y NO está en captura */}
                    {dienteActivo === String(num) && !soloLectura && !capturando && (
                      <div className="selector-tratamiento">
                        <Select
                          classNamePrefix="react-select"
                          options={tratamientos}
                          onChange={(op) => seleccionarTratamiento(num, op)}
                          placeholder="Seleccionar tratamiento"
                          isSearchable
                          menuPortalTarget={document.body}
                        />
                      </div>
                    )}
                  </div>
                ))
              }
            </div>

            <div className="arcada inferior">
              {(modo === "adulto" ? [48,47,46,45,44,43,42,41,31,32,33,34,35,36,37,38] : [85,84,83,82,81,71,72,73,74,75])
                .map(num => (
                  <div key={num} className="diente" style={generarBordes(num)}
                    data-bordes
                    onClick={() => setDienteActivo(String(num))}
                    onContextMenu={(e) => abrirMenuContextual(e, num)}
                  >
                    <img src={dientes[num]} alt={`Diente ${num}`} />
                    <div className="numero-diente-inferior">{num}</div>
                    {dienteActivo === String(num) && !soloLectura && !capturando && (
                      <div className="selector-tratamiento">
                        <Select
                          classNamePrefix="react-select"
                          options={tratamientos}
                          onChange={(op) => seleccionarTratamiento(num, op)}
                          placeholder="Seleccionar tratamiento"
                          isSearchable
                          menuPortalTarget={document.body}
                        />
                      </div>
                    )}
                  </div>
                ))
              }
            </div>
          </div>

          <div className="leyenda-container">
            <h4>Tratamientos</h4>
            <input className="filtro-leyenda" placeholder="Buscar tratamiento..." value={filtroTratamiento} onChange={(e) => setFiltroTratamiento(e.target.value)} />
            <table>
              <tbody>
                {(() => {
                  const actualesValues = odontograma.datos[dienteActivo]?.tratamientos?.map(t => t.value) || [];
                  return tratamientos
                    .sort((a,b) => {
                      const aTiene = actualesValues.includes(a.value);
                      const bTiene = actualesValues.includes(b.value);
                      if (aTiene && !bTiene) return -1;
                      if (!aTiene && bTiene) return 1;
                      return a.label.localeCompare(b.label);
                    })
                    .filter(t => t.label.toLowerCase().includes(filtroTratamiento.toLowerCase()))
                    .map(t => (
                      <tr key={t.value}>
                        <td><span className="color-box" style={{ backgroundColor: t.color }}></span></td>
                        <td style={{ fontWeight: actualesValues.includes(t.value) ? "bold" : "normal" }}>{t.label}</td>
                        <td style={{ opacity: 0.7 }}>{t.importe} €</td>
                      </tr>
                    ));
                })()}
              </tbody>
            </table>
          </div>
        </div>

        {menuContextual.visible && !capturando && (
          <div className="context-menu" style={{ top: menuContextual.y, left: menuContextual.x }} onMouseLeave={cerrarMenuContextual}>
            <button onClick={solicitarEliminarDiente}>🗑️ Eliminar</button>
          </div>
        )}
      </div>
      <ModalConfirmacion
        abierto={mostrarConfirmacion}
        mensaje={`¿Seguro que deseas eliminar el diente ${dienteAEliminar}?`}
        onConfirmar={confirmarEliminarDiente}
        onCancelar={cancelarEliminarDiente}
      />
    </>
  );
});

export default Odontograma;
